import React, { useCallback, useEffect } from 'react';
import { Route, Switch, useLocation } from 'react-router';
import { NavLink, Redirect } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import {
  Layouts,
  NoInternetConnection,
} from '../../ui-kit';
import { LeftSideBar } from '../../newContainers';
import {
  UsersWrapper,
  UserWrapper,
  PermissionsWrapper,
  RolesWrapper,
  UserInvite,
  SubscriptionWrapper,
} from './components';
import { uiActions } from '../../state/ui';
import { APP_ROUTES } from '../../constants/appRoutes';
import './style.sass';
import { TYPES } from '../../constants/users';
import { getUserData } from '../../state/user/selectors';

const PermissionsWrapperCreate = () => (<PermissionsWrapper action="Create" />);
const PermissionsWrapperEdit = () => (<PermissionsWrapper action="Edit" />);

export const Settings = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const { type } = useSelector(getUserData);
  const setAppTitle = useCallback((value) => {
    dispatch(uiActions.setAppTitle(value));
  });

  useEffect(() => {
    setAppTitle('Settings - Avanga 2.0');
  }, []);
  return (
    <Layouts.Main>
      <LeftSideBar>
        <nav className="sub-nav">
          <h3 className="sub-nav__title">{t('General')}</h3>
          <NavLink
            className="sub-nav__link"
            activeClassName="sub-nav__link--active"
            isActive={() => [APP_ROUTES.PREFERENCES_USERS, APP_ROUTES.PREFERENCES_ROLES]
              .includes(pathname)}
            to={APP_ROUTES.PREFERENCES_USERS}
          >
            {t('Users/Roles')}
          </NavLink>
          <NavLink
            className="sub-nav__link"
            activeClassName="sub-nav__link--active"
            to={APP_ROUTES.PREFERENCES_SUBSCRIPTION}
          >
            {t('Subscription')}
          </NavLink>
        </nav>
      </LeftSideBar>
      <div className="main-container main-container--settings">
        <NoInternetConnection>
          <Switch>
            <Route exact path="/preferences/users/invite-user/" component={UserInvite} />
            <Route exact path="/preferences/users/" component={UsersWrapper} />
            <Route exact path="/preferences/users/:userId/" component={UserWrapper} />
            <Route exact path="/preferences/roles/create/" component={PermissionsWrapperCreate} />
            <Route exact path="/preferences/roles/:roleId/" component={PermissionsWrapperEdit} />
            <Route exact path="/preferences/roles/" component={RolesWrapper} />
            <Route exact path="/preferences/" component={UsersWrapper} />
            {type === TYPES.ADMIN ? (<Route exact path="/preferences/subscription/" component={SubscriptionWrapper} />) : (<Redirect to="/" />)}
            <Route component={UsersWrapper} />
          </Switch>
        </NoInternetConnection>
      </div>
    </Layouts.Main>
  );
};
